import React, { useState, useEffect } from 'react';
import { useMatrixClient } from './hooks/useMatrixClient';
import { LoginForm } from './components/LoginForm';
import { ObserverView } from './components/ObserverView';

function App() {
  const { client, isLoggedIn, isLoading, error, login, logout } = useMatrixClient();

  if (isLoading) {
    return (
      <div className="app">
        <div className="loading">
          <div className="loading-spinner" />
          <p>Initializing...</p>
        </div>
      </div>
    );
  }

  if (!isLoggedIn) {
    return (
      <div className="app">
        <LoginForm onLogin={login} error={error} isLoading={isLoading} />
      </div>
    );
  }

  return (
    <div className="app">
      <ObserverView client={client} onLogout={logout} />
    </div>
  );
}

export default App;
